import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import classnames from "classnames";
import AdminEventOverview from "./AdminEventOverview";
import AdminEventInvitation from "./AdminEventInvitation";
import AdminEventSchedule from "./AdminEventSchedule";
import AdminEventContact from "./AdminEventContact";
import AdminEventFaq from "./AdminEventFaq";
import AdminEventExperiences from "../AdminEventExperiences/AdminEventExperiences";
import AdminEventPartnership from "../AdminEventPartnership/AdminEventPartnership";
import AdminEventSubmittedRegistrationMessage from "./AdminEventSubmittedRegistrationMessage";
import {loadEventsAction} from "~/Admin/redux/actions/event";

import './admineventcontent.scss';

const AdminEventContent = ({match, event, ...props}) => {

    const [active, setActive] = useState('Overview');

    const tabs = [
        'Overview',
        'Invitation',
        'Schedule',
        'Experiences',
        'Partnership',
        'FAQ',
        'Contact',
        'Submitted Registration Message'
    ];

    const updated = () => {
        props.dispatch(loadEventsAction());
    };

    return (
        <div className="admin-event-content">
            <div className="row">
                <div className="col-8">
                    <h2>Content Management</h2>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-3">
                    <div className="list-group">
                        {tabs.map(item =>
                            <a key={item} onClick={(e) => setActive(item)}
                               className={classnames('list-group-item list-group-item-action cursor-pointer', {active: active === item})}>
                                {item}
                            </a>
                        )}
                    </div>
                </div>
                {active && (
                    <div className="col-9">
                        {active === 'Overview' && <AdminEventOverview onChange={updated} />}
                        {active === 'Invitation' && <AdminEventInvitation onChange={updated} />}
                        {active === 'Schedule' && <AdminEventSchedule onChange={updated} />}
                        {active === 'Experiences' && <AdminEventExperiences onChange={updated} />}
                        {active === 'Partnership' && <AdminEventPartnership onChange={updated} />}
                        {active === 'Contact' && <AdminEventContact onChange={updated} />}
                        {active === 'FAQ' && <AdminEventFaq onChange={updated} />}
                        {active === 'Submitted Registration Message' && <AdminEventSubmittedRegistrationMessage onChange={updated} />}
                    </div>
                )}
            </div>
        </div>

    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventContent);
